// extracted by mini-css-extract-plugin
export var cardContainer = "_r2-0";
export var cardHeader = "_r2-2";
export var collapsedState = "_r2-3";
export var dragHandle = "_r2-5";
export var dragHandleIcon = "_r2-6";
export var dragging = "_r2-1";
export var titleArea = "_r2-4";